// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching company registration trends
// export const fetchCompanyRegistrationTrends = createAsyncThunk(
//   "companyRegistration/fetchTrends",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         "http://localhost:3000/super-admin/company-registration-trends"
//       );
//       const result = await response.json();

//       if (result.success) {
//         return result.data;
//       } else {
//         return rejectWithValue(result.message || "Failed to fetch data");
//       }
//     } catch (error) {
//       return rejectWithValue("Error connecting to server");
//     }
//   }
// );

// const companyRegistrationSlice = createSlice({
//   name: "companyRegistration",
//   initialState: {
//     registrationData: null,
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//     resetState: (state) => {
//       state.registrationData = null;
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCompanyRegistrationTrends.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCompanyRegistrationTrends.fulfilled, (state, action) => {
//         state.loading = false;
//         state.registrationData = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchCompanyRegistrationTrends.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearError, resetState } = companyRegistrationSlice.actions;
// export default companyRegistrationSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching company registration trends
export const fetchCompanyRegistrationTrends = createAsyncThunk(
  "companyRegistration/fetchTrends",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/company-registration-trends`
      );
      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || "Failed to fetch data");
      }
    } catch (error) {
      return rejectWithValue("Error connecting to server");
    }
  }
);

const companyRegistrationSlice = createSlice({
  name: "companyRegistration",
  initialState: {
    registrationData: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetState: (state) => {
      state.registrationData = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyRegistrationTrends.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyRegistrationTrends.fulfilled, (state, action) => {
        state.loading = false;
        state.registrationData = action.payload;
        state.error = null;
      })
      .addCase(fetchCompanyRegistrationTrends.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, resetState } = companyRegistrationSlice.actions;
export default companyRegistrationSlice.reducer;
